$(function () {
  let services = [];
  let bookingId = null;

  /**
   * fetchBooking — replace this with your real $.ajax call to booking_search.php
   *
   * Real PHP version would look like:
   *   $.ajax({
   *     url: 'booking_search.php',
   *     type: 'POST',
   *     data: { booking_reference: ref },
   *     dataType: 'json',
   *     success: resolve,
   *     error: () => reject({ success: false, message: 'Network error.' })
   *   });
   */
  function fetchBooking(ref) {
    const organizerId = $('body').attr('organizer_id');
    services = [];
    bookingId = null;
    return $.ajax({
      method: 'POST',
      url: '/api/v1/private/park-and-fly/search-booking',
      data: { booking_reference: ref, organizer_id: organizerId },
      dataType: 'json',
    });
  }

  /* ── Helpers ── */
  function fmtDate(d) {
    if (!d) return '—';
    const dt = new Date(d);
    return dt.toLocaleDateString('en-GB', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
    });
  }
  function fmtTime(t) {
    if (!t || t === '00:00:00') return '—';
    return t.slice(0, 5);
  }
  function fmtPrice(n, currency) {
    return n === 0
      ? `<span class="service-price free">Free</span>`
      : `<span class="service-price">${n.toLocaleString()} ${currency}</span>`;
  }
  function statusBadge(s) {
    const icons = {
      pending: 'bi-clock',
      paid: 'bi-check-circle-fill',
      cancelled: 'bi-x-circle-fill',
    };
    return `<span class="payment-badge ${s}"><i class="bi ${icons[s] || 'bi-circle'}"></i>${s.charAt(0).toUpperCase() + s.slice(1)}</span>`;
  }

  /* ── Render booking ── */
  function renderBooking(b) {
    const c = b.client;
    const v = b.vehicle;
    const sc = b.schedule;
    const cb = b.cost_breakdown;

    const servicesHtml = b.services
      .map(
        (s) => `
      <div class="service-row">
        <span class="service-name">${s.title}</span>
        ${fmtPrice(s.price, cb.currency)}
      </div>`
      )
      .join('');

    return `
    <div class="booking-card">
      <hr class="divider"/>
 
      <!-- Ref + status row -->
      <div class="d-flex flex-wrap align-items-center justify-content-between ref-status-row mb-3">
        <div class="ref-badge"><i class="bi bi-hash"></i>${b.booking_reference}</div>
        ${statusBadge(b.payment_status)}
      </div>
 
      <div class="result-area">
        <!-- Client -->
        <div class="section-title"><i class="bi bi-person-fill"></i>Client</div>
        <div class="info-grid mb-3">
          <div class="info-cell full">
            <div class="label">Full Name</div>
            <div class="value">${c.name}</div>
          </div>
          <div class="info-cell">
            <div class="label">Email</div>
            <div class="value">${c.email}</div>
          </div>
          <div class="info-cell">
            <div class="label">Phone</div>
            <div class="value">${c.phone}</div>
          </div>
        </div>
 
        <!-- Vehicle -->
        <div class="section-title"><i class="bi bi-car-front-fill"></i>Vehicle</div>
        <div class="info-grid mb-3">
          <div class="info-cell">
            <div class="label">Brand</div>
            <div class="value">${v.brand}</div>
          </div>
          <div class="info-cell">
            <div class="label">Model</div>
            <div class="value">${v.model}</div>
          </div>
        </div>
 
        <!-- Schedule -->
        <div class="section-title"><i class="bi bi-calendar3"></i>Schedule</div>
        <div class="info-grid mb-3">
          <div class="info-cell">
            <div class="label">Departure</div>
            <div class="value">${fmtDate(sc.departure_date)}</div>
          </div>
          <div class="info-cell">
            <div class="label">Return</div>
            <div class="value">${fmtDate(sc.return_date)}</div>
          </div>
          <div class="info-cell">
            <div class="label">Drop-off Time</div>
            <div class="value">${fmtTime(sc.drop_off_time)}</div>
          </div>
          <div class="info-cell">
            <div class="label">Total Days</div>
            <div class="value">${sc.total_days} day${sc.total_days !== 1 ? 's' : ''}</div>
          </div>
        </div>
 
        <!-- Services -->
        ${
          b.services.length
            ? `
        <div class="section-title"><i class="bi bi-wrench-adjustable"></i>Services</div>
        <div class="info-cell mb-3" style="padding:.4rem .9rem;">${servicesHtml}</div>
        `
            : ''
        }
 
        <!-- Cost Breakdown -->
        <div class="section-title"><i class="bi bi-receipt"></i>Cost Breakdown</div>
        <div class="info-cell mb-1">
          <div class="cost-row"><span>Parking cost</span><span>${cb.base_parking_cost.toLocaleString()} ${cb.currency}</span></div>
          <div class="cost-row"><span>Peak season multiplier</span><span>×${cb.peak_season_multiplier}</span></div>
          <div class="cost-row"><span>Parking after peak</span><span>${cb.parking_cost_after_peak.toLocaleString()} ${cb.currency}</span></div>
          <div class="cost-row"><span>Services subtotal</span><span>${cb.services_subtotal.toLocaleString()} ${cb.currency}</span></div>
          <div class="cost-row subtotal-row"><span>Subtotal</span><span>${cb.subtotal_before_discount.toLocaleString()} ${cb.currency}</span></div>
          ${
            cb.discount_percentage > 0
              ? `
          <div class="cost-row discount-row">
            <span class="discount-label">
              <i class="bi bi-tag-fill mr-1"></i>Discount
              <span class="discount-pct-pill">${cb.discount_percentage}% OFF</span>
            </span>
            <span class="discount-val">−${cb.discount_amount.toLocaleString()} ${cb.currency}</span>
          </div>`
              : ''
          }
          <div class="cost-row total">
            <span>Total Payable</span>
            <span class="cost-val">${cb.total_payable.toLocaleString()} ${cb.currency}</span>
          </div>
        </div>
      </div>
    </div>`;
  }

  /* ── Render error ── */
  function renderError(msg) {
    return `
    <div class="mt-3">
      <div class="error-box">
        <i class="bi bi-exclamation-triangle-fill"></i>
        <div>${msg}</div>
      </div>
    </div>`;
  }

  /* ── Search logic ── */
  function setLoading(on) {
    if (on) {
      $('#searchBtnText').addClass('d-none');
      $('#searchBtnSpinner').removeClass('d-none');
      $('#searchBtn').prop('disabled', true);
      $('#bookingRef').prop('disabled', true);
    } else {
      $('#searchBtnText').removeClass('d-none');
      $('#searchBtnSpinner').addClass('d-none');
      $('#searchBtn').prop('disabled', false);
      $('#bookingRef').prop('disabled', false);
    }
  }

  function doSearch() {
    const ref = $('#bookingRef').val().trim();
    if (!ref) {
      $('#bookingRef').focus();
      return;
    }

    setLoading(true);
    $('#resultArea').html('');

    const data = fetchBooking(ref)
      .then((response) => {
        if (response.success && response.booking) {
          $('#resultArea').html(renderBooking(response.booking));
          services = response.cart_products || [];
          bookingId = response.booking.booking_id || null;
        }
      })
      .fail((response) => {
        $('#resultArea').html(
          renderError(
            response.responseJSON.error.message || 'Booking not found.'
          )
        );
      })
      .always(() => setLoading(false));
  }

  /* ── Events ── */
  $(document).on('click', '#searchBtn', doSearch);

  $(document).on('keypress', '#bookingRef', function (e) {
    if (e.key === 'Enter') doSearch();
  });

  $(document).on('click', '#add-to-cart-services', function () {
    if (services.length === 0) {
      $('#bookingModal').modal('hide');
      return;
    }
    setClassicLocationCart({
      ...locationCart,
      products: services,
      checkout_type: 'normal',
      booking_reference: $('#bookingRef').val().trim(),
      booking_id: bookingId,
      number_of_products: services.length,
    });
    $('#bookingModal').modal('hide');
  });

  // Reset on modal open
  $('#bookingModal').on('show.bs.modal', function () {
    $('#bookingRef').val('');
    $('#resultArea').html('');
  });

  $('#bookingModal').on('shown.bs.modal', function () {
    $('#bookingRef').focus();
  });
});
